module.exports = __webpack_public_path__ + "static/media/cereali.7eacfb81.svg";